module.exports = __webpack_public_path__ + "img/nxinlogo.cc110f53.png";